import { Component, Shark, Utils } from "shark-mvc";

import templateContent from "../../_shark_templates/components/picture-tools.html";
import { pictureManager } from "../managers/pictureManager.js";

class PictureToolsComponent extends Component {
	constructor () {
		super("pictureToolsComponent");
		this.addTemplate("", templateContent);
	}

	deletePictureBtn_clickHandler (event, data) {
		if (confirm("Sei sicuro di voler eliminare questa immagine?")) {
			const currPicture = Utils.safp(Shark.get("pictureList"), "guid", data.guid);
			
			if (currPicture) {
				pictureManager.delete(currPicture);
			}
		}
	}
	
	showPictureBtn_clickHandler (event, data) {
		console.log(data.guid);
	}
	
}

const pictureToolsComponent = new PictureToolsComponent();

Shark.registerComponent(pictureToolsComponent);

export { pictureToolsComponent };
